// extracted by css-extract-rspack-plugin
export default {"TagContainer":"EUakC","TagName":"wYYGj","Parameter":"VS1n_"};